import React, {Component} from 'react';
import './list.css';
import Constant from "./constant.js"
import {changZykAudioCount, getAnalyze, getZykAudioList} from '../../actions'
import {List, Pagination, Spin} from "antd";
import {connect} from "react-redux";
import $ from "jquery";
import {applicationName, formatSeconds} from '../../utils'
import {HEADER_HEIGHT} from "../../constants";

class AudioList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            count: 0,
            size: Constant.configPagesize,
            start: 1,
            loading: false,
            height: applicationName() === 'pms' ? window.innerHeight - HEADER_HEIGHT - 172 : window.innerHeight - HEADER_HEIGHT - 272,
        }
    }

    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        this.setState({
            loading: true,
        })
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }
        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": this.state.start,
            "size": this.state.size
        };
        getZykAudioList(param, this.updateAudioList.bind(this))
    }

    updateAudioList(result) {
        this.props.changZykAudioCount(result.count);

        //处理前台的分页信息
        let resultData = result.data;
        this.setState({
            data: resultData,
            loading: false,
            count: result.count
        });


    }

    /**
     * 分词在页面高亮显示；
     * @param data
     */
    lightAnayWorldInList(data) {
        //按照优先级排序
        console.log('lightAnayWorldInList audio_list');
        let listData = data.sort(function (a, b) {
            return b.length - a.length
        });
        //定义正则表达式对象  array[i]是关键字   "g"是指全局范围
        let a = new RegExp(listData.join("|"), "g");
        $(".content-header").each(function () {
            var html = $(this)[0].getAttribute('title')
            html = html.replace(a, function (item) {
                return "<span style='color:#F00'>" + item + "</span>"
            });
            $(this).html(html);
        });
    }

    //页面高亮显示
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.tableKey === 3) {
            console.info("audio_list");
            //分词处理，分词高亮显示；
            if (this.props.searchText) {
                let param = {
                    str: this.props.searchText
                }
                //请求后台获取分词数据
                getAnalyze(param, this.lightAnayWorldInList.bind(this));
            } else {
                $(".content-header").each(function () {
                    if ($(this).find('span')[0] && $(this).find('span')[0].style) {
                        $(this).find('span')[0].style.color = '#000';
                    }
                });
            }
        }
    }


    //插入音频文件
    insertAudio(data) {
        if (applicationName() === 'contribute') {
            let param = {
                "url": data.ZykAudio_path,
                "title": data.ZykAudio_name
            }
            window.frames[0].ueditor.execCommand('music', param);

            let param2 = {
                "success": true,
                "url": data.ZykAudio_path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": 0,
                    "md5": "",
                    "name": data.ZykAudio_name,
                    "path": data.ZykAudio_path,
                    "prefix": "",
                    "size": data.ZykAudio_size,
                    "storageDirectoryId": [],
                    "suffix": data.ZykAudio_ext,
                    "type": 4,
                    "url": "",
                    "width": 0
                },
                "state": "SUCCESS",
                "title": data.ZykAudio_name,
                "original": data.ZykAudio_name
            }
            window.frames[0].cmSitesFileUploadAfterCallbackFun(param2);
        } else {
            let param = {
                "url": data.ZykAudio_path,
                "title": data.ZykAudio_name
            }
            window.parent.ueditor.execCommand('music', param);

            let param2 = {
                "success": true,
                "url": data.ZykAudio_path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": 0,
                    "md5": "",
                    "name": data.ZykAudio_name,
                    "path": data.ZykAudio_path,
                    "prefix": "",
                    "size": data.ZykAudio_size,
                    "storageDirectoryId": [],
                    "suffix": data.ZykAudio_ext,
                    "type": 4,
                    "url": "",
                    "width": 0
                },
                "state": "SUCCESS",
                "title": data.ZykAudio_name,
                "original": data.ZykAudio_name
            }
            window.parent.cmSitesFileUploadAfterCallbackFun(param2);
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {

        if (nextProps.tableKey === 3) {
            this.setState({
                loading: true,
                start: 1,
            })

            let onlyMe = 1;
            if (nextProps.onlyMe) {
                onlyMe = 0
            }
            let param = {
                "query": nextProps.searchText,
                "isAll": onlyMe,
                "start": 1,
                "size": this.state.size
            };
            //请求后台获取稿件列表数据
            getZykAudioList(param, this.updateAudioList.bind(this));
        }
    }

    getZykAudioPageList(page, pageSize) {

        this.setState({
            loading: true,
        })
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }

        this.setState({
            start: page
        })

        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": page,
            "size": pageSize,
        };
        //请求后台获取图片列表数据
        getZykAudioList(param, this.updateAudioList.bind(this));
    }


    addHoverRemark() {
        $(".audioList").on('mouseenter', '.file-box', function () {
            $(this).find(".image-remake").animate({bottom: "0px"}, 300);
        })

        $(".audioList").on('mouseleave', '.file-box', function () {
            $(this).find(".image-remake").animate({bottom: "-35px"}, 300);
        });
    }


    /**
     * 音频试听功能
     * @param record
     */
    audioTopreview(record) {

        let data = {
            "mediaFusionAudio": {
                "path": record.ZykAudio_path
            },
            "title": record.ZykAudio_name,
            "coverPic": '/cm-sites/images/music.png',
        };

        let parent;
        if (applicationName() === 'pms') {
            parent = window.parent;
        } else {
            parent = window.frames[0];
        }

        parent.layui.config({
            base: '/cm-sites/layuiadmin/modules/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(['storage'], function () {
            let content = '/cm-sites/'+window.env+'/previewMedia/audio-view.html';
            var storage = parent.layui.storage;
            storage.set("current-audio", data);

            parent.layer.open({
                type: 2,
                area: ['800px', '600px'],
                title: data.title,
                content: content
            });
        });
    }

    componentDidMount() {
        this.addHoverRemark();

    }


    render() {
        return (
            <Spin spinning={this.state.loading}>
                <div className="audioList" style={{height: this.state.height + 'px', overflow: "auto"}}>
                    <List
                        itemLayout="vertical"
                        size="large"
                        dataSource={this.state.data}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    title={<div className="item-box">
                                        <div className="file-box" onClick={() => this.insertAudio(item)}>
                                            <img
                                                src={item.ZykAudio_coverUrl !== "" ? item.ZykAudio_coverUrl : 'images/audio.png'}/>
                                            <div className="image-remake">
                                                插入正文
                                            </div>
                                        </div>
                                        <div className={"content-box content-box-" + applicationName()}>
                                            <p className={"content-header audio-name"}
                                               title={item.ZykAudio_name}
                                               dangerouslySetInnerHTML={{__html: item.ZykAudio_name}}></p>
                                            <p className="content-img-size"><img
                                                onClick={this.audioTopreview.bind(this, item)}
                                                style={{cursor: 'pointer'}} src="images/listen.png"/>
                                                <span
                                                    style={{paddingLeft: '10px'}}>{formatSeconds(item.ZykAudio_allTime)}</span>
                                            </p>
                                            <p className="content-bottom">
                                                <span>来源:{Constant.getDataSource(item.ZykAudio_dataSource)}</span>
                                                <span titile={item.ZykAudio_createDate}>日期:{item.ZykAudio_createDate}</span>
                                            </p>
                                        </div>
                                    </div>}
                                />
                            </List.Item>
                        )}
                    />
                </div>
                <div className='pageTables'>
                    <Pagination showLessItems={true} current={this.state.start} total={this.state.count}
                                defaultPageSize={this.state.size}
                                defaultCurrent={1}
                                onChange={(page, pageSize) => {
                                    this.getZykAudioPageList(page, pageSize)
                                }} onShowSizeChange={(page, pageSize) => {
                        this.getZykAudioPageList(page, pageSize)
                    }}/>
                </div>
            </Spin>
        );
    }
}

function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch: state.zykReducer.doSearch
    }
}

function mapStateToMethod(dispatch) {
    return {
        changZykAudioCount: function (zykStoryCount) {
            return dispatch(changZykAudioCount(zykStoryCount));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(AudioList);
